module.exports = __webpack_public_path__ + "static/media/education.50795730.jpg";